import { render, staticRenderFns } from "./CardTipoDePagamento.vue?vue&type=template&id=5f1b2b42&scoped=true&"
import script from "./CardTipoDePagamento.vue?vue&type=script&lang=js&"
export * from "./CardTipoDePagamento.vue?vue&type=script&lang=js&"
import style0 from "./CardTipoDePagamento.vue?vue&type=style&index=0&id=5f1b2b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b2b42",
  null
  
)

export default component.exports